
//职位名称  职位级别
const columnList: Array<column> = [
    {
        prop: "name",
        label: "菜单名称",
        width: 125,
    },
    {
        prop: "path",
        label: "path",
        width: 300,
    },
    {
        prop: "weight",
        label: "排序",
        width: 100,
    },
    {
        prop: "isshow",
        label: "状态",
        width: 100,
    },
];

import {
    defineComponent,
    ref,
    reactive,
    inject,
    provide,
    onMounted,
    watch,
} from "vue";
import { useRoute, useRouter } from "vue-router";
import { column } from "@/assets/types/common";
import { Request } from "@/api/request";

export default defineComponent({
    name: "Menu",
    setup() {
        const setTitle: any = inject("setTitle");
        setTitle(["门店管理", "菜单管理"]);
        let pageSize = ref(10),
            currentPage = ref(1),
            total = ref(0),
            tableData = ref([] as Array<any>),
            loading = ref(true),
            headClass = inject("headClass"),
            menuType = ref(1),
            handleSizeChange = (value: number): void => {
                pageSize.value = value;
                getTableData();
            },
            handleCurrentChange = (pageSize: number): void => {
                currentPage.value = pageSize;
                getTableData();
            },
            setStatus = (id: number, type: number): void => {
                if (id) {
                    Request.axiosInstance({
                        url: "adminapi/Privilege/upState",
                        data: {
                            id,
                            type,
                        },
                    }).then((res: any) => {
                        getTableData();
                    });
                }
            },
            getTableData = (): void => {
                loading.value = true;
                Request.axiosInstance({
                    url: "adminapi/Privilege/menuList",
                    data: {
                        page: currentPage.value,
                        pagesize: pageSize.value,
                        type: menuType.value,
                    },
                }).then((res: any) => {
                    tableData.value = res?.content?.list || [];
                    loading.value = false;
                    total.value = res?.content?.total || 0;
                });
            };

        onMounted(() => {
            getTableData();
        });
        watch(menuType, () => {
            getTableData();
        });

        return {
            columnList,
            tableData,
            loading,
            total,
			pageSize,
			currentPage,
            headClass,
            menuType,
            handleSizeChange,
            handleCurrentChange,
            setStatus,
        };
    },
});
